import Tecnologia from  './Tecnologia';

export default Tecnologia;